import { Injector } from "@angular/core";
import { MeddraService } from "../../../../service/meddra-service/meddra.service";
import { MeddraNode, MeddraLevel, HierarchyMode } from "../MeddraNode";
import { TreeNodeMeddraLevelItem } from "./TreeNodeMeddraLevelItem";
import { HLGTListView } from "../../../Data/MeddraData/HLGTListView";
import { environment } from "../../../../../../environments/environment";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { PTListView } from "../../../Data/MeddraData/PTListView";
import { MeddraTerm } from "../../../Data/MeddraData/MeddraTerm";
import { FieldDefinition } from "../../../../../sections/meddra/message/fieldDefinition";
import { DummyNode } from "../../DummyNode";
import { EntityEnum } from "../../EntityEnum";
import { BaseNode } from "../../BaseNode";


export class TreeNodeHLTItem extends TreeNodeMeddraLevelItem {

    constructor(injector: Injector, data: any, parent: BaseNode) {
        super(injector, data, EntityEnum.hlt, injector.get(Art57Section).meddra.hltTermsTreeNode, parent);
        this.children?.push(new DummyNode());
    }

    override createChildren(): void {
        //Retrieve "Preferred term for this HL term"
        let ptNode = new MeddraNode(this.ioc!, new PTListView([]), `Preferred Terms ({param})`, EntityEnum.pt,null, this, HierarchyMode.DESCENDING);
        this.children!.push(ptNode);
        this.ioc?.get(MeddraService).getAll(this,EntityEnum.pt, `hlt_code:eq:${this.data.model.code}`).subscribe(
            {
                next: (data:any) => {
                    ptNode.data = new PTListView(data.result);
                    data.result.forEach((i: any) => ptNode.children!.push(new MeddraNode(this.ioc!, new MeddraTerm(new FieldDefinition(this.ioc!).ptFields, i), i.name, EntityEnum.pt, this.ioc!.get(Art57Section).meddra.ptTermsTreeNode, ptNode, HierarchyMode.DESCENDING)));
                    ptNode.refreshLabel();
                }, error: () => {
                    this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Error found', life: environment.errorElapsedTime });
                }
            });


        //Retrieve "High Level Group Terms for this HL term"
        let hlgtNode = new MeddraNode(this.ioc!, new HLGTListView([]), `High Level Group Terms ({param})`, EntityEnum.hlgt, null, this, HierarchyMode.ASCENDING);
        this.children!.push(hlgtNode);
        this.ioc?.get(MeddraService).getAll(this,EntityEnum.hlgt, `hlt_code:eq:${this.data.model.code}`).subscribe(
            {
                next: (data:any) => {
                    hlgtNode.data=new HLGTListView(data.result);
                    data.result.forEach((i: any) => hlgtNode.children!.push(new MeddraNode(this.ioc!, new MeddraTerm(new FieldDefinition(this.ioc!).hlgtFields, i), i.name, EntityEnum.hlgt, this.ioc!.get(Art57Section).meddra.hlgtTermsTreeNode, hlgtNode,HierarchyMode.ASCENDING)));
                    hlgtNode.refreshLabel();
                }, error: () => {
                    this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Error found', life: environment.errorElapsedTime });
                }
            });
    }
}